import React from 'react';
import { Formik } from 'formik';
import store from '../store';
import actionCreators from '../store/actionCreators';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';
import format from '../utils/format';
import { connect } from 'react-redux';
import { getBase } from '../utils/fetchAPI';
import isComplexEnough from '../utils/isComplexEnough';
import getAllReactDescendents from '../utils/getAllReactDescendents';

const mapStateToProps = (state, props) => ({
  messages: state.content.translations,
  locale: state.state.locale,
  loading: state.state.forms[props.id] || false,
  apiServer: getBase()
});

const onFocus = e => actionCreators.closeBanner('message401');

export const Form = props => {
  const {
    children,
    targetURL,
    ErrorURL500,
    submitAction,
    onSubmit,
    endPoint,
    id,
    method = 'POST',
    delay = 0,
    initialValues = {},
    initialErrors
  } = props;

  if (!id) {
    if (process.env.NODE_ENV === 'development') {
      throw new Error('Form must have an id.');
    }
  }

  var url = props.apiServer + endPoint;

  const t = k => format(props.messages, props.locale, k);

  return (
    <Formik
      initialValues={initialValues}
      initialErrors={initialErrors}
      validationOnChange={true}
      enableReinitialize={true}
      validationOnBlur={false}
      validate={values => {
        let allDescendents, i, oneChild, results;
        allDescendents = getAllReactDescendents({props: {children: children}});
        results = {};
        for (i = 0; i < allDescendents.length; i++) {
          oneChild = allDescendents[i];
          if (oneChild.props.required && !values[oneChild.props.name]) {
            if (oneChild.props.required_message) {
              results[oneChild.props.name] = t(oneChild.props.required_message);
            } else {
              results[oneChild.props.name] = 'required';
            }
          } else if (
            oneChild.props.mustMatch &&
            values[oneChild.props.name] !== values[oneChild.props.mustMatch]
          ) {
            results[oneChild.props.name] = 'mustMatch';
          } else if (
            oneChild.props.minimumLength &&
            values[oneChild.props.name].length < oneChild.props.minimumLength
          ) {
            results[oneChild.props.name] = 'minimum';
          } else if (
            oneChild.props.complexity &&
            !isComplexEnough(values[oneChild.props.name])
          ) {
            results[oneChild.props.name] = 'complexity';
          }
        }
        return results;
      }}
      onSubmit={(values, actions) => {
        if (targetURL) {
          values.targetURL = targetURL;
        }
        if (ErrorURL500) {
          values.ErrorURL500 = ErrorURL500;
        }
        if (submitAction) {
          store.dispatch(
            actionCreators[submitAction](values, url, method, delay)
          );
        }
        if (onSubmit) {
          onSubmit(values);
        }
      }}
      render={({ handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit} id={id} data-testid={id}>
          <div style={{ textAlign: 'center', height: 0 }}>
            <Fade in={props.loading} unmountOnExit>
              <CircularProgress />
            </Fade>
          </div>
          {children.map(el => {
            const { name, 'data-testid': testId } = el.props;

            const cloneProps = {
              onFocus,
              isSubmitting
            };

            if (props.loading) {
              cloneProps.disabled = true;
            }

            if (name && (initialValues[name] === null || typeof initialValues[name] === 'undefined')) {
              initialValues[name] = '';
            }

            if (!testId) {
              cloneProps['data-testid'] = `${id}.${name}`;
            }

            return React.cloneElement(el, cloneProps);
          })}
        </form>
      )}
    />
  );
};

export default connect(mapStateToProps)(Form);
